/**
 * @fileoverview 認証コレクション collection
 *
 */
'use strict';
// Library Import
import _ from 'lodash';
import Backbone from 'backbone';
// Collection Import
import CommonCollection from './CommonCollection';
// Util Import
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import ConnectionUtil from '../util/ConnectionUtil';

/**
 * 認証コレクション
 *
 * @class AuthCollection
 * @extends {CommonCollection}
 */
class AuthCollection extends CommonCollection {
  /**
   * Creates an instance of AuthCollection.
   * @memberof AuthCollection
   */
  constructor() {
    let param = {
      baseModel: null,
      listResponseKey: ''
    };
    super(param);
  }

  /**
   *  ログイン
   *
   * @param {Object} callback  コールバック
   * @param {Object} payload ペイロード
   * @memberof AuthCollection
   */
  login(callback, payload) {
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };
    ConnectionUtil.callAPI(ConstUtil.Common.API_LIST.login, request, function(
      err,
      res
    ) {
      if (err) {
        callback.failure(err);
        return;
      }
      callback.success(res.data);
      return;
    });
  }

  /**
   *  ログアウト
   *
   * @param {Object} callback  コールバック
   * @memberof AuthCollection
   */
  logout(callback, payload) {
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: payload
    };
    let self = this;
    ConnectionUtil.callAPI(ConstUtil.Common.API_LIST.logout, request, function(
      err,
      res
    ) {
      if (err) {
        callback.failure(err);
        return;
      }
      callback.success(res.data);
      return;
    });
  }
}
export default AuthCollection;



// WEBPACK FOOTER //
// ./src/js/collection/AuthCollection.jsx